<template>
  <div>
    
    <loading 
        :active.sync="load" 
        :is-full-page="true"
        color="green"
        ></loading>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    
    <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn color="primary" round @click="exportCompletedData()">Export Completed Orders</v-btn>
         <div>
    <applicationpagemodal
    @submitComplete="fetchAfterOrderAdd()"
    ></applicationpagemodal>
  </div>
        <v-text-field
      v-if="showNewApplications"
        v-model="pendingSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          pendingOffset: $route.query.pendingOffset,
          resolvedOffset: $route.query.resolvedOffset,
          pendingSearch: pendingSearch,
          resolvedSearch: $route.query.resolvedSearch,
          records: $route.query.records
          }})"
      ></v-text-field>
      <v-text-field
      v-if="showResolvedApplications"
        v-model="resolvedSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          pendingOffset: $route.query.pendingOffset,
          resolvedOffset: $route.query.resolvedOffset,
          pendingSearch: $route.query.pendingSearch,
          resolvedSearch: resolvedSearch,
          records: $route.query.records
          }})"
      ></v-text-field>
    </v-toolbar>
    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab @click="showNewApplications=true;showResolvedApplications=false">
          Pending Orders <v-chip color="primary" class="white--text">{{pendingTotalItems}}</v-chip>
        </v-tab>
        <v-tab @click="showNewApplications=false;showResolvedApplications=true">
          Completed Orders  <v-chip color="secondary" class="white--text">{{resolvedTotalItems}}</v-chip>
        </v-tab>
        <!-- <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab> -->
      </v-tabs>
    </v-toolbar>

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <v-flex  v-if="showNewApplications">
    <v-data-table
    v-if="showNewApplications"
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :rows-per-page-items="[$route.query.records]"
      :loading="loading"
      :items="newApplications"
      item-key="id"
      disable-initial-sort
      align-center
      style="cursor: pointer"
      hide-actions
    >
      <template v-slot:items="props">
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{formatDate(props.item.createdAt)}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.id}}</td>
         <td v-if="props.item.location"
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        >{{props.item.location.locationDescription}}</td>
           <td v-else
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        >{{formattedAddress(props.item)}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.packagesIspId&&props.item.ispVerified&&props.item.ispAccepted">
          <v-chip color="success" class="white--text">Accepted</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else-if="props.item.packagesIspId&&props.item.ispVerified&&!props.item.ispAccepted">
                  <v-chip color="red" class="white--text">Rejected</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else-if="props.item.packagesIspId">
                  <v-chip color="warning" class="white--text">Pending</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
                  <v-chip color="black" class="white--text">N/A</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isInstallVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>

        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isDeviceVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>

        <!-- <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isPackageVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td> -->

        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isContactVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>
        <td class="text-xs-center" v-if="props.item.primaryContactTitle!==null" @click="routerLinkToDetails(props.item)">{{props.item.primaryContactTitle + ' '+props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>
        <td class="text-xs-center" v-else @click="routerLinkToDetails(props.item)">{{props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>
        
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.primaryContactMobileNumber}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.primaryContactEmailAddress}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.pendingOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="pendingPage"
              :length="Math.ceil(pendingTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
  </v-flex>
    <v-flex  v-if="showResolvedApplications">
      <v-data-table
      :headers="resolvedHeaders"
      class="elevation-1"
      :rows-per-page-items="[$route.query.records]"
      :loading="loading"
      :items="resolvedApplications"
      item-key="id"
      disable-initial-sort
      align-center
      style="cursor: pointer"
      hide-actions
    >
      <template v-slot:items="props">
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.id}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.location.locationDescription}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isApproved">
        <v-chip class="green white--text">Approved</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-chip class="red white--text">Denied</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{formatDate(props.item.createdAt)}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{formatDate(props.item.resolvedDate)}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.resolvedById">{{props.item.resolvedBy.name}} {{props.item.resolvedBy.surname}}</td>
          <td v-else></td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
        {{props.item.deniedReason}}
        </td>
        <td v-if="props.item.primaryContactId!==null" class="text-xs-center" @click="routerLinkToDetails(props.item)">
        {{props.item.primaryContact.name}} {{props.item.primaryContact.surname}}
        </td>
        <td class="text-xs-center" v-else></td>
        <td v-if="props.item.primaryContactId!==null" class="text-xs-center" @click="routerLinkToDetails(props.item)">
        {{props.item.primaryContact.mobileNumber}}
        </td>
        <td class="text-xs-center" v-else></td>
        <td v-if="props.item.primaryContactId!==null" class="text-xs-center" @click="routerLinkToDetails(props.item)">
        {{props.item.primaryContact.emailAddress}}
        </td>
        <td class="text-xs-center" v-else></td>
        
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
    <div class="text-xs-center pt-2 white" :key="$route.query.resolvedOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="resolvedPage"
              :length="Math.ceil(resolvedTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
     
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import applicationPageModal from "@/components/ApplicationPageModal.vue";
export default {
   components: {
        loading: Loading,
        applicationpagemodal: applicationPageModal
    },
  data() {
    return {
      pendingPage: 1,
      pendingPagination: {},
      pendingSearch: "",
      pendingTotalItems: 0,
      resolvedPage: 1,
      resolvedPagination: {},
      resolvedSearch: "",
      resolvedTotalItems: 0,
      load: true,
      showDetails: true,
      showNewApplications:true,
      showResolvedApplications:false,
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      snackbar: false,
      text: "",
      y: "top",
      allVlans:[],
      newApplications: [],
      newDialog: false,
      resolvedPagination: {
          descending: true,
      activeTabName: '',
      sortBy: "resolvedDate"
          },
          pagination: {
      descending: true,
      activeTabName: '',
      sortBy: "createdAt"
    },
    tabs: [
        { name: "newApplications", displayName: "Pending" },
        { name: "resolvedApplications", displayName: "Resolved" }
      ],
      resolvedHeaders: [
        {
          text: "Order ID:",
          align: "center",
          value: "id"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Status",
          align: "center",
          sortable: false
        },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Resolved Date",
          align: "center",
          value: "resolvedDate"
        },
        {
          text: "Resolved By",
          align: "center",
          value: 'resolvedBy'
        },
        {
          text: "Comment",
          align: "center",
          value: 'deniedReason'
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber"
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress"
        }
      ],
      headers: [
        // {
        //   text: "Actions",
        //   align: "center"
        // },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Order ID",
          align: "center",
          value: "id"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        // {
        //   text: "Invoice",
        //   align: "center",
        //   value: "invoiceNumber"
        // },
        // {
        //   text: "Invoice Paid",
        //   align: "center",
        //   value: "isPaid"
        // },
        {
          text: "ISP Acceptance",
          align: "center",
          value: "ispVerified"
        },
        {
          text: "Install Verified",
          align: "center",
          value: "isInstallVerified"
        },
        {
          text: "Device Verified",
          align: "center",
          value: "isDeviceVerified"
        },
        {
          text: "Contact Verified",
          align: "center",
          value: "isContactVerified"
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber"
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress"
        }
      ],
      totalApplications: 0,
      applications: [],
      editedIndex: -1,
      editedItem: {

        primaryTitle: "",
        primaryName: "",
        primarySurname: "",
        primaryMobileNumber: "",
        primaryEmailAddress: "",
        primaryIdNumber: "",
        isPropertyOwner: "",
        secondaryTitle: "",
        secondaryName: "",
        secondarySurname: "",
        secondaryMobileNumber: "",
        secondaryEmailAddress: "",
        secondaryIdNumber: "",
        isOrganisation: "",
        organisationName: "",
        billingTitle: "",
        billingName: "",
        billingSurname: "",
        billingMobileNumber: "",
        billingEmailAddress: "",
        billingIdNumber: "",

        isActive: true,
        isDeleted: false
      },
      defaultItem: {

        primaryTitle: "",
        primaryName: "",
        primarySurname: "",
        primaryMobileNumber: "",
        primaryEmailAddress: "",
        primaryIdNumber: "",
        isPropertyOwner: "",
        secondaryTitle: "",
        secondaryName: "",
        secondarySurname: "",
        secondaryMobileNumber: "",
        secondaryEmailAddress: "",
        secondaryIdNumber: "",
        isOrganisation: "",
        organisationName: "",
        billingTitle: "",
        billingName: "",
        billingSurname: "",
        billingMobileNumber: "",
        billingEmailAddress: "",
        billingIdNumber: "",

        isActive: true,
        isDeleted: false
      }
    };
  },

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
     // Pending Applications
    '$route.query.pendingSearch':{
      immediate: true,
      handler(value){
        //this.load=true
      if(this.$route.query.pendingSearch&&value!==""&&value != null){
        this.pendingPage = 1
        Api()
        .get('/customer/applications/pending',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.load=false
          })} else if(this.$route.query.pendingOffset){
             Api()
        .get('/customer/applications/pending',{
          params: {
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.load=false})
          }
      }
    },
    '$route.query.pendingOffset': {
       immediate: true,
      handler(value){
        //this.load=true
      if(value!==""&&value != null&&this.$route.query.pendingSearch&&this.$route.query.pendingSearch!="" &&this.$route.query.pendingSearch!== null){      
        
        Api()
        .get('/customer/applications/pending',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.load=false})
      } else if(value != null){
         Api()
        .get('/customer/applications/pending',{
          params: {
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.load=false})
      }
    }},
     pendingPage(value) {
      this.pendingPagination.page = this.pendingPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.pendingSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.activeSearch
            }
          });
        }
      }
    },

    // Resolved
    '$route.query.resolvedSearch':{
      immediate: true,
      handler(value){
        //this.load=true
      if(this.$route.query.resolvedSearch&&value!==""&&value != null){
        this.resolvedPage = 1
        Api()
        .get('/customer/applications/resolved',{
          params: {
          search: this.$route.query.resolvedSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedApplications=response.data.result
          this.resolvedTotalItems=response.data.count
            this.load=false
          })} else if(this.$route.query.resolvedOffset){
             Api()
        .get('/customer/applications/resolved',{
          params: {
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedApplications=response.data.result
          this.resolvedTotalItems=response.data.count
            this.load=false})
          }
      }
    },
    '$route.query.resolvedOffset': {
       immediate: true,
      handler(value){
        console.log(value)
        //this.load=true
      if(value!==""&&value != null&&this.$route.query.resolvedSearch&&this.$route.query.resolvedSearch!="" &&this.$route.query.resolvedSearch!== null){      
        
        Api()
        .get('/customer/applications/resolved',{
          params: {
          search: this.$route.query.resolvedSearch,
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedApplications=response.data.result
          this.resolvedTotalItems=response.data.count
            this.load=false})
      } else if(value != null){
         Api()
        .get('/customer/applications/resolved',{
          params: {
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedApplications=response.data.result
          this.resolvedTotalItems=response.data.count
            this.load=false})
      }
    }},
     resolvedPage(value) {
       
      this.resolvedPagination.page = this.resolvedPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.resolvedSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        }
      }
    },
  },

  async created() {
     this.$router.push({
      name: this.$route.name,
      query: {
        pendingOffset: "0",
        resolvedOffset: "0",
        records: "15"
      }
    })
        this.initialize();
  },

  methods: {
     exportCompletedData(){
        Api()
        .get("/customer/applications/resolved/export").then(response=>{
          var hiddenElement = document.createElement('a');
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'completed_orders.csv';
          hiddenElement.click();
        })
    },
    formattedAddress(val){
      let address = ''
      if(val.unitNo){
        address += 'Unit '+val.unitNo +', '
      }
      if(val.floorNo){
        address += 'Floor '+val.floorNo +', '
      }
      if(val.building){
        address += val.building +', '
      }
      if(val.streetNumber){
        address += val.streetNumber +' '
      }
      if(val.streetName){
        address += val.streetName +', '
      }
      if(val.suburb){
        address += val.suburb +', '
      }
      if(val.town){
        address +=val.town +', '
      }
      if(val.province){
        address += val.province +', '
      }
      if(val.country){
        address += val.country
      }
      if(val.postalCode){
        address +=  ' ' + val.postalCode
      }
      return address
    },
    async routerLinkToDetails(item) { 
      let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/ispApplications/:applicationId'})
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/ispApplications/" + this.editedItem.id });
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
   
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    }, 
    fetchAfterOrderAdd(){
      this.load=true
       this.setActiveTabName('newApplications')
       this.pendingPage = 1
        Api()
        .get('/customer/applications/pending',{
          params: {
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.load=false
        })
    },
    initialize() {
      this.setActiveTabName('newApplications')
    },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedIndex = this.applications.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      }
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }
  }
};
</script>
